import * as React from 'react';

import { S9FormContainer } from '@april9au/stack9-forms';

interface IProps {
  formId: string;
  height?: string;
  className?: string;
  onSubmit?: () => void;
}

const Stack9Form: React.FC<IProps> = ({
  formId,
  className,
  height,
  onSubmit,
}) => {
  const stack9FormUrl = ENV?.STACK9_FORM_URL;
  const [hasError, setHasError] = React.useState(false);

  // Don't render if URL is not configured or if error occurred
  if (!stack9FormUrl || hasError) {
    return null; // Silently fail
  }

  return (
    <S9FormContainer
      s9FormBaseUrl={stack9FormUrl}
      s9FormId={formId}
      targetElementId={`stack9-form-${formId}`}
      height={height || '400px'}
      onError={() => {
        // Silently handle error - don't log
        setHasError(true);
      }}
      onComplete={onSubmit}
      className={className}
    />
  );
};

export default Stack9Form;
